export const usageMap = [
	{
		slug: 'blog_media',
		title: 'a blog, publishing or media website',
	},
	{
		slug: 'retail_ecommerce',
		title: 'a retail and/or eCommerce website',
	},
	{
		slug: 'clients',
		title: 'my clients’ websites',
	},
	{
		slug: 'small_business',
		title: 'a website for my small/local business',
	},
	{
		slug: 'saas',
		title: 'a SaaS/software website',
	},
	{
		slug: 'nonprofit',
		title: 'a nonprofit, school or government website',
	},
	{
		slug: 'other',
		title: 'none of the above. My business is...',
	},
];

export const goalMap = [
	{
		slug: 'grow',
		title: 'grow my email list',
	},
	{
		slug: 'reduce_abandonment',
		title: 'reduce cart abandonment',
	},
	{
		slug: 'targeted_offers',
		title: 'show targeted offers',
	},
	{
		slug: 'social_media',
		title: 'increase my social media following',
	},
	{
		slug: 'generate_leads',
		title: 'generate more leads from my website traffic',
	},
	{
		slug: 'reduce_bounce_rate',
		title: 'reduce the bounce rate on my site',
	},
	{
		slug: 'redirect_traffic',
		title: 'redirect traffic to key pages on my site',
	},
];

export const featureMap = [
	{
		slug: 'campaigns',
		title: 'All Campaign Types',
		description: 'Lightbox popups, floating bars, fullscreen welcome mats, slide-ins and more!',
		free: true,
	},
	{
		slug: 'page-level-targeting',
		title: 'Page Level Targeting',
		description: 'Use behavior personalization to display page-specific campaigns on your website.',
		free: true,
	},
	{
		slug: 'wpforms',
		title: 'WPForms',
		description: 'Build Smarter Forms and Surveys with WPForms',
		plugin: {
			title: 'WPForms',
			slug: 'wpforms-lite/wpforms.php',
		},
	},
	{
		slug: 'google-analytics',
		title: 'Google Analytics for WordPress',
		description:
			'Properly connect your site to <a href="#">Google Analytics</a> to make data-driven decisions, no coding needed.',
		plugin: {
			title: 'Google Analytics Dashboard Plugin for WordPress by MonsterInsights',
			slug: 'google-analytics-for-wordpress/googleanalytics.php',
		},
	},
	{
		slug: 'seo',
		title: 'All in One SEO',
		description:
			'Powerful toolkit to improve your <a href="#">SEO rankings</a> and uncover new growth opportunities.',
		plugin: {
			title: 'All-in-One SEO Pack',
			slug: 'all-in-one-seo-pack/all_in_one_seo_pack.php',
		},
	},
	{
		slug: 'social-proof',
		title: 'TrustPulse',
		description:
			'Leverage the true power of <a href="#">social proof</a> to increase site conversions by up to 15%!',
		plugin: {
			title: 'TrustPulse',
			slug: 'trustpulse-api/trustpulse.php',
		},
	},
	{
		slug: 'landing-pages',
		title: 'SeedProd Website Theme Builder',
		description: "Create High Converting Landing Pages & Websites. 100's of Templates.",
		plugin: {
			title: 'Website Builder by SeedProd',
			slug: 'coming-soon/coming-soon.php',
		},
	},
	{
		slug: 'pushengage',
		title: 'Push Notifications',
		description: 'Send personalized push notifications to visitors with PushEngage.',
		plugin: {
			title: 'PushEngage',
			slug: 'pushengage/main.php',
		},
	},
	{
		slug: 'split-test',
		featureId: 'ab-testing',
		title: 'A/B Split Testing',
		description: 'Eliminate the guesswork by testing your different content in your campaigns.',
	},
	{
		slug: 'exit-intent',
		title: 'Exit-Intent® Targeting',
		description: "Personalize your campaigns based on your visitor's behavior to maximize conversions.",
	},
	{
		slug: 'yesno',
		featureId: 'yesno-buttons',
		title: 'Yes / No Multi-Step Campaigns ',
		description: 'Create multi-step campaigns to boost traffic and grow your email list.',
	},
	{
		slug: 'coupon-wheel-campaigns',
		title: 'Gamified Coupon Wheel',
		description: 'Create interactive spin-a-wheel games to instantly multiply sales and conversions.',
		usage: 'retail_ecommerce',
	},
	{
		slug: 'content-locker',
		title: 'Content Locker',
		description: 'Grow your email list fast by locking your most in-demand content on your website.',
		usage: 'blog_media',
	},
	{
		slug: 'onsite-targeting',
		title: 'OnSite Retargeting & Follow Up Campaigns',
		description: 'Reduce abandonment and boost sales by customizing promotions for returning visitors.',
	},
];

export const emailProviders = [
	{
		slug: 'mailchimpv3',
		title: 'Mailchimp',
	},
	{
		slug: 'constant-contact',
		title: 'Constant Contact',
	},
	{
		slug: 'activecampaign',
		title: 'ActiveCampaign',
	},
	{
		slug: 'aweber',
		title: 'AWeber',
	},
	{
		slug: 'hubspot',
		title: 'HubSpot',
	},
	{
		slug: 'klaviyo',
		title: 'Klaviyo',
	},
	{
		slug: 'infusionsoft-oauth',
		title: 'Keap (Infusionsoft)',
	},
	{
		slug: 'drip',
		title: 'Drip',
	},
	{
		slug: 'convertkit',
		title: 'ConvertKit',
	},
	{
		slug: 'getresponse',
		title: 'GetResponse',
	},
	{
		slug: 'pardot',
		title: 'Pardot',
	},
	{
		slug: 'sendinblue-v2',
		title: 'Brevo (formerly Sendinblue)',
	},
	{
		slug: 'campaign-monitor',
		title: 'Campaign Monitor',
	},
	{
		slug: 'conversio',
		title: 'Conversio',
	},
	{
		slug: 'customerio',
		title: 'Customer.io',
	},
	{
		slug: 'dotdigital',
		title: 'DotDigital',
	},
	{
		slug: 'eloqua',
		title: 'Eloqua',
	},
	{
		slug: 'emailoctopus',
		title: 'EmailOctopus',
	},
	{
		slug: 'emma',
		title: 'Emma',
	},
	{
		slug: 'feedblitz',
		title: 'Feedblitz',
	},
	{
		slug: 'icontact',
		title: 'iContact',
	},
	{
		slug: 'ipost',
		title: 'iPost',
	},
	{
		slug: 'jilt',
		title: 'Jilt',
	},
	{
		slug: 'madmimi',
		title: 'Mad Mimi',
	},
	{
		slug: 'mailerlite',
		title: 'MailerLite',
	},
	{
		slug: 'mailpoet',
		title: 'MailPoet',
	},
	{
		slug: 'marketo',
		title: 'Marketo',
	},
	{
		slug: 'ontraport',
		title: 'Ontraport',
	},
	{
		slug: 'sendloop',
		title: 'Sendloop',
	},
	{
		slug: 'sendpulse',
		title: 'SendPulse',
	},
	{
		slug: 'sharpspring',
		title: 'SharpSpring',
	},
	{
		slug: 'other',
		title: 'Other',
	},
];
